import * as React from "react";
import { Control, FieldPathValue, FieldValues, Path, useController } from "react-hook-form";
import { Form, FormInputProps } from "semantic-ui-react";

interface SemanticReactHookFormsInputProps<
    TFormModel extends FieldValues,
    TName extends Path<TFormModel>
> extends Omit<FormInputProps, "control"> {
    name: FieldPathValue<TFormModel, TName> extends FormInputProps["value"] ? TName : never;
    control: Control<TFormModel>;
    disabled?: boolean;
}

export const SemanticReactHookFormsInput = <
    TFormModel extends FieldValues,
    TName extends Path<TFormModel>
>({ control, name, ...props }: SemanticReactHookFormsInputProps<TFormModel, TName>) => {
    const {
        field: { ref, ...field }, fieldState: { error }
    } = useController({
        name,
        control,
        disabled: props.disabled
    });

    return <Form.Input input={{ ref }} {...props} {...field} error={error?.message} />;
};
